import dayjs from 'dayjs'
import { CloseButtonProps } from 'react-toastify'
import { useAppDispatch, useAppSelector } from '../types'
import { setUserPreferences } from '../userPreferences/actions'
import { getUserPreferences } from '../userPreferences/selectors'

const CookieCloseButton = ({ closeToast }: CloseButtonProps) => {
  const dispatch = useAppDispatch()
  const userPreferences = useAppSelector(getUserPreferences)

  const acceptCookie = () => {
    const date = dayjs()
    const cookieConsentDate = date.toDate().toUTCString()
    const newPreferences = {
      ...userPreferences,
      cookieConsentDate
    }
    dispatch(setUserPreferences(newPreferences))
    const expiration = date.add(1, 'year').toDate().toUTCString()
    document.cookie = `accepted-cookies=${1}; expires=${expiration};`
  }

  const handleClick = () => {
    acceptCookie()
    closeToast()
  }

  return (
    <button
      style={{ margin: '0 auto', paddingTop: '0.2rem' }}
      onClick={handleClick}
    >
      Accept
    </button>
  )
}

export default CookieCloseButton
